import React from 'react';
import EnrollEmployee from '../../../Layout/Enrollment/EnrollEmployee';
import HomePage from '../../../Layout/Enrollment/HomePage';

export default [
  { path: "/enrollment/enrollEmployee", component: EnrollEmployee },
  { path: "/enrollment/home", component: HomePage },
]